<div class="base">
    <div class="contenedor">
        <div class="contenido">
            <div class="selectbox">
                <div class="selectbox-header">
                    <h4>{{sbTitulo}}</h4>
                </div>
                <div class="selectbox-body">
                    <div class="grupobotones">
                        <input type="text" class="usrselecdiv usrcombo" id="txtSelect" placeholder=""
                            value="{{filtroTxtSelect}}" (click)="abrirCombo('txtSelect')" autocomplete="off">
                    </div>
                    <p><br><br><br><br></p>
                </div>
                <div *ngIf="verBotones" class="selectbox-footer" [ngStyle]="lineaBotonesStyle">
                    <div (click)="emitirRespuesta('Aceptar')" class="selectbox-button" [ngStyle]="aceptarStyle">Aceptar
                    </div>
                    <div (click)="emitirRespuesta('Cancelar')" class="selectbox-button" [ngStyle]="botonStyle">Cancelar
                    </div>
                </div>
                <div *ngIf="!verBotones" class="selectbox-footer" [ngStyle]="lineaBotonesStyle">
                    <div  class="selectbox-button" [ngStyle]="invisibleStyle">.
                    </div>
                    <div class="selectbox-button" [ngStyle]="invisibleStyle">.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>